import { QuestionMarkCircleIcon } from '@heroicons/react/24/solid';
import type { VariantProps } from 'class-variance-authority';
import type { FC } from 'react';
import { cn } from '../../../lib/utils';
import { Tooltip } from '../../tooltip/Tooltip';
import type { TextProps, TextPropsWithAs } from '../helpers/types';
import { resolveColor } from '../helpers/utils';
import { textVariants } from '../helpers/variants';

import { TextBase } from './TextBase';

type TextVariant = NonNullable<VariantProps<typeof textVariants>['variant']>;

/** variant に応じたアイコンサイズ */
const HINT_ICON_SIZE: Record<TextVariant, string> = {
  h1: 'size-8',
  h2: 'size-7',
  h3: 'size-6',
  h4: 'size-5',
  subhead: 'size-4',
  body: 'size-3.5',
  label: 'size-3.5',
  link: 'size-3.5',
  description: 'size-3',
};

export const Text: FC<TextProps> = (props) => {
  if (props.hint && !props.hint.hidden) {
    const variant = props.variant ?? 'body';
    const resolvedColor = resolveColor(variant, props.color);
    const asElement = ('as' in props ? props.as : undefined) ?? 'span';

    return (
      <span
        className={cn(textVariants({ variant: null, color: resolvedColor }), props.hint.className)}
      >
        <TextBase {...(props as TextPropsWithAs)} as={asElement} />
        <Tooltip tooltipContent={props.hint.value} contentClassName="whitespace-pre-line">
          <QuestionMarkCircleIcon
            className={cn('ml-0.5 inline -translate-y-[1.5px]', HINT_ICON_SIZE[variant])}
          />
        </Tooltip>
      </span>
    );
  }
  return <TextBase {...props} />;
};
